const PersonalDataProtection = (props) => {
  return (
    <>
      <div
        className="modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto"
        id="personalDataProtectionModal"
        tabIndex="-1"
        aria-labelledby="personalDataProtectionLabel"
        aria-modal="true"
        role="dialog"
      >
        <div
          className="modal-dialog modal-lg relative w-auto pointer-events-none overflow-hidden"
          style={{ zIndex: "1200 !important" }}
        >
          <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current h-screen-87vh">
            <div className="modal-body relative p-12 overflow-y-scroll">
              <h4 className="text-gray-800 font-semibold text-base text-center">
                UNILEVER DIGI-CALL
                <br />
                KİŞİSEL VERİLERİN İŞLENMESİNE DAİR AYDINLATMA METNİ
              </h4>
              <br />
              <p className="text-sm">
                Unilever Sanayi ve Ticaret Türk A.Ş. olarak ( "Unilever" veya
                "Şirket") olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu
                ("KVKK") uyarınca, veri sorumlusu sıfatıyla, işleme amacı ile
                bağlantılı, sınırlı ve ölçülü olacak şekilde talep ettiğimiz ve
                bizimle paylaşmış olduğunuz adınız, soyadınız, e-posta
                adresiniz, telefonunuz, üniversiteniz, bölümünüz, sınıfınız,
                cinsiyetiniz, görüntünüz, sesiniz, ve özgeçmiş bilgilerinizin de
                aralarında bulunabileceği kişisel verilerinizin,
                digicall.unilever.com.tr internet sitesine erişim hakkınızın
                tesis edilmesi ve Şirket’imizin hukuki yükümlülüklerini yerine
                getirebilmesine ilişkin hukuki sebep ve amaç çerçevesinde;
                kaydedilecek, depolanacak, muhafaza edilecek, yeniden
                düzenlenecek, hukuken bu kişisel verileri talep etmeye yetkili
                olan kurumlar ile paylaşılacak, KVKK’nın ve diğer kanunların
                öngördüğü koşullarda yurt içinde mukim üçüncü kişilere
                aktarılabilecek, devredilebilecek, sınıflandırılabilecek ve
                KVKK’da sayılan diğer şekillerde işlenebilecek olduğunu
                bildiririz.
                <br />
                <br />
                Digi-Call’a katılımınız dolayısıyla, işbu Aydınlatma Metni’ne
                uygun olarak paylaşmış olduğunuz kişisel verileriniz söz konusu
                etkinliğe katılımınızdan doğan yükümlülüklerimizin ifası ve
                kanuni yükümlülüklerimiz kapsamında ve bu amaçlarla kullanılarak
                kampanya kapsamında hizmet sağlayan 3. Kişi ve kurum olan 3İK
                İletişim Ajansı Danışmanlık Tasarım ve Organizasyon Hizmetleri
                Limited Şirketi ile paylaşılacak, bu amaçlarla sınırlı olarak
                işlenecek ve yasal yükümlülüklerimizin gerektirdiği yasal
                sürelerin hitamı ile ilk periyodik imha döneminde imha
                edilecektir.
                <br />
                <br />
                Kişisel verileriniz yukarıda belirtilen amaçlarla
                paylaşılabilecektir ve hizmet aldığımız kişilerin yurtiçindeki
                güvenli sunucularında ilgili yasal düzenlemelere, KVKK
                hükümlerine ve Unilever standartlarına uygun olarak
                saklanacaktır. Bu kapsamda Unilever, kişisel verilerinizin
                güvenliğini sağlamak adına yasal mevzuat ile belirlenen gerekli
                teknik ve idari güvenlik önlemlerini almaktadır.
                <br />
                <br />
                KVKK’nın 11. maddesi uyarınca başvurarak, kişisel verilerinizin;
                <br />
                <br />
              </p>
              <ol className="text-sm list-[lower-latin] pl-4">
                <li>işlenip işlenmediğini öğrenme,</li>
                <br />
                <li>işlenmişse bilgi talep etme,</li>
                <br />
                <li>
                  işlenme amacını ve amacına uygun kullanılıp kullanılmadığını
                  öğrenme,
                </li>
                <br />
                <li>
                  yurt içinde / yurt dışında aktarıldığı 3. kişileri bilme,
                </li>
                <br />
                <li>eksik / yanlış işlenmişse düzeltilmesini isteme,</li>
                <br />
                <li>
                  KVKK’nın 7. maddesinde öngörülen şartlar çerçevesinde
                  silinmesini / yok edilmesini isteme,{" "}
                </li>
                <br />
                <li>
                  aktarıldığı 3. kişilere yukarıda sayılan (e) ve (f) bentleri
                  uyarınca yapılan işlemlerin bildirilmesini isteme,
                </li>
                <br />
                <li>
                  münhasıran otomatik sistemler ile analiz edilmesi nedeniyle
                  aleyhinize bir sonucun ortaya çıkmasına itiraz etme,{" "}
                </li>
                <br />
                <li>
                  hukuka aykırı olarak işlenmesi sebebiyle zarara uğramanız
                  hâlinde zararın giderilmesini talep etme hakkına sahipsiniz.{" "}
                </li>
              </ol>
              <br />
              <p className="text-sm">
                Bu bölümde listelenmiş olan haklarınızı aşağıdaki adrese yazılı
                başvuruda bulunarak ya da{" "}
                <a
                  className="text-blue-600"
                  href="https://www.unilever.com.tr/contact/contact-form"
                >
                  https://www.unilever.com.tr/contact/contact-form
                </a>{" "}
                adresindeki iletişim formu aracılığıyla veya Unilever tüketici
                hattı 444 25 19 numarasını arayarak kullanabilirsiniz: Unilever
                Sanayi ve Ticaret Türk A.Ş. Saray Mahallesi Dr. Adnan Büyükdeniz
                Caddesi No: 13 37768 Ümraniye, İstanbul
              </p>
            </div>
            <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
              <button
                type="button"
                className="px-4 py-2 mr-2 bg-red-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-700 active:shadow-lg transition duration-150 ease-in-out"
                data-bs-dismiss="modal"
              >
                Kapat
              </button>
              <label
                htmlFor={!props.isChecked ? "personaldataprotection" : ""}
                data-bs-dismiss="modal"
                className="px-4 py-2 bg-green-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-600 hover:shadow-lg focus:bg-green-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-600 active:shadow-lg transition duration-150 ease-in-out cursor-pointer"
              >
                Onaylıyorum
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PersonalDataProtection;
